import {getLocale} from '@epic-core/common';
import {sanitizeCopy} from '@epic-mw/common-utils/dist/contentUtils';

/**
 * Replace any occurances of :locale and replace it will the current locale
 */
export const replaceDynamicLocale = (text: string): string => {
    let finalText = text;
    // Replace any occurances of :locale and replace it will the current locale
    if (finalText && finalText.indexOf(':locale') > -1) {
        const locale = getLocale();
        finalText = finalText.replace(/href="\/:locale/gi, `href="/${locale}`);
    }
    return finalText;
};

/**
 * Execute some replacements of the raw string data coming from the WYSIWYG of our CMS
 * @param richText
 * @returns
 */
export const modifyRichTextContent = (richText?: string): string | undefined => {
    let updatedRichText = richText || '';

    updatedRichText = sanitizeCopy(updatedRichText);
    updatedRichText = replaceDynamicLocale(updatedRichText);

    return updatedRichText;
};
